<template>
    <div class="meeting-calendar mx-4 mb-4">
        <b-row class="mb-4">
            <b-col cols="6" class="d-flex align-items-center">
                <h2 class="mb-0 pr-3">{{ title }}</h2>

                <!-- Previous Month -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 320 512" class="cursor-pointer mx-2" @click.prevent="prev"><path fill="#192B46" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>

                <!-- Next Month -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 320 512" class="cursor-pointer mx-2" @click.prevent="next"><path fill="#192B46" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
            </b-col>

            <b-col cols="6">
                <el-select v-model="selectedView" @change="changeView">
                    <el-option
                    v-for="view in viewOptions"
                    :key="view.value"
                    :label="view.label"
                    :value="view.value">
                    </el-option>
                </el-select>
            </b-col>
        </b-row>
        <!-- <FullCalendar ref="fullCalendar" :options="calendarOptions" /> -->
        <div id="fullCalendar"></div>

        <AddNewMeeting :create_meeting.sync="modals.create_meeting" :start="modals.start" :end="modals.end" @listLead="fetchLead" :dateInfo="dateInfo"/>
          <modal :show.sync="showAddModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
              <!-- FIELD EVEN TITLE -->
              <base-input
                name="title"
                label="Event title"
                placeholder="Event Title"
                v-model="model.title"
                input-classes="form-control-alternative new-event--title"
              >
              </base-input>

              <!-- FIELD STATUS COLOR -->
              <!-- <div class="form-group">
                <label class="form-control-label d-block mb-3">Status color</label>
                <div class="btn-group btn-group-toggle btn-group-colors event-tag">
                  <label
                    v-for="color in eventColors"
                    :key="color"
                    class="btn"
                    :class="[color, { 'active focused': model.className === color }]"
                  >
                    <input
                      v-model="model.className"
                      type="radio"
                      name="event-tag"
                      :value="color"
                      autocomplete="off"
                    />
                  </label>
                </div>
              </div> -->
              <div class="form-group">
                <label class="form-control-label d-block mb-3">Status color</label>
                <div class="btn-group btn-group-toggle btn-group-colors event-tag">
                  <label
                    v-for="(color, index) in eventColors"
                    :key="index"
                    class="btn"
                    :class="[color.label, { 'active focused': model.className === color.label }]"
                  >
                    <input
                      v-model="model.className"
                      type="radio"
                      name="event-tag"
                      :value="color.label"
                      autocomplete="off"
                    />
                  </label>
                </div>
              </div>
              <input type="hidden" class="new-event--start" />
              <input type="hidden" class="new-event--end" />
            </form>

            <template v-slot:footer>
              <button
                type="submit"
                class="btn btn-primary new-event--add"
                @click="saveEvent"
              >
                Add event
              </button>
              <button
                type="button"
                class="btn btn-link ml-auto"
                @click="showAddModal = false"
              >
                Close
              </button>
            </template>
          </modal>

      <!-- EDIT MODAL FOR THE MEETING -->
      <modal :show.sync="showEditModal" modal-classes="modal-secondary medium-sized-modal event-modal">
        <h3 slot="header" class="mb-0 font-weight-500">Update Meeting</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form @submit.prevent="editEvent">
                    <b-row>
                        <input type="text" v-model="model.call_id" hidden>
                        <input type="text" v-model="model.lead_id" hidden>
                        <input type="text" v-model="model.call_status" hidden>

                        <!-- FIELD LEADS -->
                        <b-col cols="12" md="12">
                            <b-form-group label="Lead Name:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallLead'"
                                >
                                <!-- <el-select v-model="model.lead_id" filterable placeholder="Select" disabled>
                                    <el-option
                                    v-for="lead in leadName"
                                    :key="lead.lead_id"
                                    :label="lead.name"
                                    :value="lead.lead_id">
                                    </el-option>
                                </el-select> -->

                                <b-input-group>
                                <!-- <b-form-input v-model="model.name"></b-form-input> -->
                                  <b-form-select v-model="model.lead_id" disabled>
                                    <b-form-select-option v-for="lead in leadName" :key="lead.lead_id" :label="lead.name" :value="lead.lead_id">Option 1</b-form-select-option>
                                  </b-form-select>
                                    <b-input-group-append>
                                        <b-button variant="primary">
                                          <!-- <el-button type="text" class="name py-0"> -->
                                              <router-link :to="'/leadProfileDetails/'+model.lead_id" class="text-white">
                                                Detail
                                              </router-link>
                                            <!-- </el-button> -->
                                        </b-button>
                                    </b-input-group-append>
                              </b-input-group>

                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD CALL TITLE -->
                        <b-col cols="12">
                            <b-form-group label="Subject:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallTitle'"
                                >
                                <b-form-input
                                    name="title2"
                                    v-model="model.title"
                                    input-classes="form-control-alternative new-event--title"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD MEETING DESCRIPTION -->
                        <b-col cols="12">
                            <b-form-group label="Description:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'meetingDescription'"
                                >
                                    <b-form-textarea
                                    id="textarea"
                                    v-model="model.description"
                                    placeholder="Description"
                                    rows="3"
                                    max-rows="6"
                                    required
                                    ></b-form-textarea>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD DATE START -->
                        <b-col cols="12" md="6">
                            <b-form-group label="Date Start">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallType'"
                                >
                                <b-form-datepicker v-model="model.start" id="dateInput" readonly></b-form-datepicker>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD DATE END -->
                        <b-col cols="12" md="6">
                            <b-form-group label="Date Start">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallType'"
                                >
                                <b-form-datepicker v-model="model.end" id="dateInput" readonly></b-form-datepicker>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>

                        <!-- FIELD TIME START -->
                        <b-col cols="12" md="6">
                            <b-form-group label="Time Start:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallStartTime'"
                                >
                                <el-time-picker
                                    v-model="model.start_time"
                                    placeholder="Time Start"
                                    format="HH:mm A"
                                    value-format="HH:mm:ss"
                                    >
                                </el-time-picker>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD TIME END -->
                        <b-col cols="12" md="6">
                            <b-form-group label="Time End:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallEndTime'"
                                >
                                <el-time-picker
                                    v-model="model.end_time"
                                    placeholder="Time End"
                                    format="HH:mm A"
                                    value-format="HH:mm:ss"
                                    >
                                </el-time-picker>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD HUB (Assigned To) -->
                        <!-- <b-col cols="12" md="12">
                            <b-form-group label="Assigned To:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallHub'"
                                >
                                <el-select v-model="model.assigned_to" filterable placeholder="Select">
                                    <el-option
                                    v-for="hub in hubName"
                                    :key="hub.hub_id"
                                    :label="hub.hub_name"
                                    :value="hub.hub_id">
                                    </el-option>
                                </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col> -->
                        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                            <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Update</b-button>
                        </b-col>
                    </b-row>
                </b-form>
        </ValidationObserver>

        <!-- <template v-slot:footer>
          <base-button type="link" class="mr-auto" @click="showEditModal = false"
            >Close</base-button
          >
          <base-button
            native-type="submit"
            type="primary"
            class="new-event--add"
            @click="editEvent"
            >Update</base-button
          >
        </template> -->
      </modal>
    </div>
</template>
<script>
import { Select, Option, TimePicker } from 'element-ui'
import Modal from "@/components/Modal"
import AddNewMeeting from '@/views/Meeting/MeetingModals/AddMeetingEvent'
import '@fullcalendar/core/vdom' // solves problem with Vite
// import FullCalendar from '@fullcalendar/vue'
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridDay from "@fullcalendar/timegrid"
import { EventBus } from '@/main';
import { axios, services, getHeader, debounce, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import { getYear } from 'date-fns'
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

var calendar
export default {
    components: {
        Modal,
		    AddNewMeeting,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [TimePicker.name]: TimePicker,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    data() {
        return {
          	eventsData : [
				{
					title: "All Day Event",
          description: "HELLO",
					start: new Date(2023, 4, 1).toISOString(),
					className: "event-default",
				},
			],
      		leadName: [],
			model: {
                meeting_id: "1",
                title: "New event",
                className: "bg-default",
                description:
                "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
                start: "",
                end: "",
                start_time: "",
                end_time: "",
                lead_id:"",
                meeting_status:"",
                remark_meeting:""
            },
			selectedView: 'dayGridMonth',
            title: '',
            showAddModal: false,
            showEditModal: false,
			modals: {
				create_meeting: false,
				start: new Date(),
				end: new Date()
			},
        	eventColors: [
				{
				value:"1",
				label:"event-default",
				status:"Scheduled"
				},
				{
				value:"2",
					label:"event-green",
					status:"Completed"
				},
				{
				value:"3",
					label:"event-orange",
					status:"Postponed"
				},
				{
				value:"4",
					label:"event-red",
					status:"Canceled"
				},
        	],
			viewOptions: [
				{
					value: 'dayGridMonth',
					label: 'Month'
				},
				{
					value: 'dayGridWeek',
					label: 'Week'
				},
				{
					value: 'timeGridDay',
					label: 'Day'
				},
			],
        	dateInfo: {}
        }
    },
    created(){
      this.getAllMeeting()
  
    },
    mounted() {
        EventBus.$on('closeModal', () => {
            this.closeModal()
        });
        EventBus.$on('refreshCalendar', (data) => {
          // let eventStart = this.toISOFormat(data.start_at)
          // let eventEnd = this.toISOFormat(data.end_at)
          let eventStart = (data.start_at)
          let eventEnd = (data.end_at)
          const options = {
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZone: 'Asia/Kuala_Lumpur',
            timeZoneName: 'short'
          };
          let timeStart = this.getDataTime(data.start_at)
          let timeEnd = this.getDataTime(data.end_at)
          const formattedDate = eventStart.toLocaleString('en-US', options);
          let newEventsData = {
            meeting_id:data.meeting_id,
            lead_id:data.lead_id,
            title:data.subject,
            start:eventStart,
            end:eventEnd,
            description:data.description,
            meeting_status:data.meeting_status,
            className:data.meeting_status,
            start_time:timeStart,
            end_time:timeEnd,
          }
          this.eventsData.push(newEventsData)

          this.initCalendar()
        });
    },
    methods: {
		initCalendar() {
			var calendarEl = document.getElementById("fullCalendar");
			calendar = new Calendar(calendarEl, {
				plugins: [dayGridPlugin, timeGridDay, interactionPlugin],
				initialView: 'dayGridMonth',
				selectable: true,
				headerToolbar: false,
        timeZone: 'Asia/Kuala_Lumpur',

				select: (info) => {

          var startDate = new Date(info.start);
          var endDate = new Date(info.start);
					this.modals.create_meeting = true;

          this.dateInfo = info
          
          startDate.setHours(0,0,0)
          endDate.setHours(23,59,59)

          // this.modals.create_meeting = true;
					// this.modals.start = info.start;
					// this.modals.end = info.end || info.start;
          
					// this.modals.end = info.end.setHours(23, 59, 59, 999) || info.start;

					// this.modals.start = startDate;
					// this.modals.end = endDate || startDate;
					this.modals.start = info.start;
					this.modals.end = info.start;
				},
				eventClick: (info) => {
          let event = info.event
					this.model = {
            meeting_id:event.extendedProps.meeting_id,
            lead_id: event.extendedProps.lead_id,
            className: event.extendedProps.meeting_status,
						title: event.title,
						className: event.classNames ? event.classNames.join(" ") : "",
						start: event.startStr,
						end: event.endStr,
            start_time: event.extendedProps.start_time,
            end_time: event.extendedProps.end_time,
            // end_time: event.extendedProps.end,
						description: event.extendedProps.description,
            remark_meeting: event.extendedProps.remark_meeting

						// "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
					};
					this.showEditModal = true;
				},
				dayHeaderFormat: {
					weekday: 'long'
				},
				eventTimeFormat: {
					hour: 'numeric',
					minute: '2-digit',
					omitZeroMinute: true,
					meridiem: 'short',
          timeZone: 'UTC',
				},
				events: this.eventsData,
        
        // CHANGE TAG COLOR BASED ON STATUS
        eventDidMount: function(info) {
          let data = info.event.extendedProps.meeting_status ? info.event.extendedProps.meeting_status : info
          switch (data ) {
            case 'Scheduled':
              info.el.style.backgroundColor = '#5E72E4'; // Red color for SCHEDULED events
              break;
            case 'Completed':
              info.el.style.backgroundColor = '#2DCE89'; // Green color for COMPLETED events
              break;
            case 'Postponed':
              info.el.style.backgroundColor = '#FB6340'; // Orange color for POSTPONED events
              break;
            case 'Canceled':
              info.el.style.backgroundColor = '#F5365C'; // Blue color for CANCELED events
              break;
          }
        },

        // eventContent: function(info){
        //   console.log(info.event.extendedProps.description)
        //   return [
        //     info.event.title,
        //     info.event.extendedProps.description
        //   ]
        // },
        
        eventContent: function(info) {
          console.log(info.event.extendedProps.start_time)
          const title = info.event.title;
          const start = info.event.extendedProps.start_time;
          const lead_name = info.event.extendedProps.lead_name;
          const description = info.event.extendedProps.description;
          const content = document.createElement("div");
          content.innerHTML = `
          <div class="cursor-pointer">
            <div class="fc-daygrid-event-dot"></div>
            <div class="fc-event-time">${start}</div>
            <div class="fc-event-title">${lead_name}</div>
            <div class="fc-list-item d-inline-block text-truncate" style="max-width: 150px;">${title}</div>
          </div>
          `;
          return { domNodes: [content] };
        },
			});
			calendar.render();
      this.title = calendar.view.title
		},
        next() {
           calendar.next()
            this.title = calendar.view.title
        },
        prev() {
           calendar.prev()
            this.title = calendar.view.title
        },
        changeView() {
           calendar.changeView(this.selectedView);
            this.title = calendar.view.title
        },
        saveEvent() {
            if (this.model.title) {
                let event = {
                    ...this.model,
                    allDay: true,
                };
                this.events.push(JSON.parse(JSON.stringify(event)));
                
                this.model = {
                    title: "",
                    eventColor: "bg-danger",
                    start: "",
                    end: "",
                };
            }
            this.showAddModal = false;
        },
        editEvent() {

          let newStart = this.getDataDate(this.model.start)
          let newEnd = this.getDataDate(this.model.end)

          const form = {
            'lead_id': this.model.lead_id,
            'subject': this.model.title,
            'description': this.model.description,
            'meeting_status': this.model.className,
            'start_at': newStart,
            'end_at': newEnd,
            'time_start': this.model.start_time,
            'time_end': this.model.end_time,
            'remark_meeting': this.model.remark_meeting,
          }

          axios.put(services.lead + 'meeting/' + this.model.meeting_id , form, { headers: getHeader() })
              .then(res => {
                  this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                  this.showEditModal = false
                  EventBus.$emit('refreshmeeting')
                  this.getAllMeeting()
              })
              .catch(e => {
                  this.errorFunction(e)
              })

        },
        closeModal(){
          this.modals.create_meeting= false
        },
        getAllMeeting(){
          this.eventsData =[]
          axios.get(services.lead + 'meeting', {headers: getHeader()})
          .then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let StartTime  = this.getDataTime(res.data.data[i].start_at)
                    let EndTime  = this.getDataTime(res.data.data[i].end_at)
                    let eventStart = moment(res.data.data[i].start_at).tz('Asia/Kuala_Lumpur').format('YYYY-MM-DD HH:mm:ss'); 
                    let eventEnd = moment(res.data.data[i].end_at).tz('Asia/Kuala_Lumpur').format('YYYY-MM-DD HH:mm:ss'); 
                    let newEventsData = {
                        meeting_id:res.data.data[i].meeting_id,
                        title:    res.data.data[i].subject,
                        lead_id:  res.data.data[i].lead_id,
                        lead_name:  res.data.data[i].lead_name,
                        start:    eventStart,
                        end:      eventEnd,
                        start_time: StartTime,
                        end_time: EndTime,
                        description:res.data.data[i].description,
                        className:res.data.data[i].meeting_status,
                        meeting_status: res.data.data[i].meeting_status,
                        remark_meeting: res.data.data[i].remark_meeting,
                    }
                    this.eventsData.push(newEventsData)
                  }
                  this.initCalendar()
                })
                .catch(e => {
                  this.errorFunction(e)
                })

        },
        fetchLead(data){
            this.leadName = data.data
        },
        getDataTime(data){

            const newdata = new Date(data)
            const data_hours = newdata.getHours().toString().padStart(2,'0')
            const data_minutes = newdata.getMinutes().toString().padStart(2,'0')
            const data_seconds = newdata.getSeconds().toString().padStart(2, '0');

            return `${data_hours}:${data_minutes}:${data_seconds}`
        },
        getDataDate(data){
          
          const newDate = new Date(data);

          const year = newDate.getFullYear();
          const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
          const day = newDate.getDate().toString().padStart(2, '0');

          return `${year}-${month}-${day}`;
        },
    }
}
</script>
